import { Link } from "react-router-dom";
import { Reveal } from "../../lib/reveal";

const FinalCTA = () => (
  <section data-testid="final-cta-section" className="border-t border-black/10 bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid items-center gap-10 lg:grid-cols-[1fr_auto]">
        <Reveal>
          <p className="mb-4 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-bati-sky">
            <span className="h-px w-10 bg-bati-sky" /> Parlons de votre projet
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-bati-ink sm:text-5xl lg:text-6xl">
            Vous avez un projet<br />de rénovation ?
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-bati-ink/60">
            Parlez-nous de votre projet. Nous étudions votre demande et vous recontactons pour organiser une première visite.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <Link
            to="/contact"
            data-testid="final-cta-button"
            className="inline-block bg-bati-blue px-10 py-5 text-center text-[13px] font-bold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:bg-bati-sky"
          >
            Demander une étude
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);

export default FinalCTA;
